<template>
  <!-- 白名单管理-驻矿员白名单 -->
  <div class="page-container">
    <div v-if="!isAdjust">
      <div class="whiteList_box_title">
        <div class="whiteList_box_title_desc">驻矿员白名单</div>
        <kt-button
          icon=""
          label="操作历史"
          perms="-1"
          type="text"
          size="medium"
          class="whiteList_box_title_cz"
          @click="getAdjust"/>
      </div>
      <el-divider></el-divider>
      <div class="remark">注：此白名单仅用于e集运驻矿员小程序登录使用，非白名单内手机号不可登录e集运驻矿员小程序</div>
      <!--工具栏-->
      <div class="toolbar">
        <el-form :inline="true" :model="filterForm" :size="size">
          <el-form-item label="">
            <el-input v-model="filterForm.phone" placeholder="手机号" maxlength="11" type="number"  clearable></el-input>
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-search"
              label="查询"
              perms="-1"
              type="primary"
              @click="handleSearch"
            />
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-share"
              label="重置"
              perms="-1"
              @click="getReset"
              type="primary"/>
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-plus"
              label="新增"
              perms="-1"
              type="primary"
              @click="handleAdd"
            />
          </el-form-item>
        </el-form>
      </div>
      <!--表格树内容栏-->
      <el-table
        :data="whiteList"
        stripe
        size="mini"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          width="50"
          align="center"
          fixed
          label="序号"
        ></el-table-column>
        <el-table-column
          width="120"
          prop="phone"
          align="center"
          label="手机号"
        ></el-table-column>
        <el-table-column
          align="center"
          label="权限">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.miniMineSendEnable == 0">矿发登记</el-tag>
            <el-tag v-if="scope.row.miniCheckEnable == 0">发运核对</el-tag>
            <el-tag v-if="scope.row.miniSupplyEnable == 0">矿发补录</el-tag>
            <el-tag v-if="scope.row.miniDepositEnable == 0">押金收取</el-tag>
            <el-tag v-if="scope.row.miniEntryEnable == 0">入场管理</el-tag>
            <el-tag v-if="scope.row.miniLeaveEnable == 0">出厂管理</el-tag>
            <el-tag v-if="scope.row.miniCarNumberEnable == 0">停车场管理</el-tag>
            <el-tag v-if="scope.row.miniCallNumberEnable == 0">手动叫号</el-tag>
            <el-tag v-if="scope.row.miniAdjustCarEnable==0">车辆调整</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="createTime"
          align="center"
          label="添加时间"
        ></el-table-column>
        <el-table-column
          fixed="right"
          align="left"
          width="220"
          show-overflow-tooltip
          label="操作"
        >
          <template slot-scope="scope">
             <kt-button
              icon="el-icon-connection"
              label="授权"
              perms="-1"
              @click="handleAuth(scope.row)"
            />
            <kt-button
              icon="fa fa-trash"
              label="移除白名单"
              perms="-1"
              @click="handleRemove(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding: 20px">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="totalSize"
          style="float: right"
        ></el-pagination>
      </div>
    </div>
    <!--调整历史-->
    <AdjustHistory v-if="isAdjust" @Adjust="AdjustFun"/>
    <!-- 添加角色弹窗 -->
    <el-dialog 
      width="500px"
      label-position="center"
      :title="dialogTitle"
      :visible.sync="whiteDialogVisible"
			:lock-scroll="true"
      custom-class="dialogClass"
      :close-on-click-modal="false"
      :before-close="handleClose">
        <el-form
          class="whiteForm"
          :model="whiteForm" 
          :rules="whiteListRules" 
          ref="whiteForm" 
          label-width="70px"
          :size="size"
          label-position="left"
          @keyup.enter.native="submitWhiteForm()">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="whiteForm.phone" placeholder="请输入手机号" type="number" oninput="if(value.length>11) value=value.slice(0,11)"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button :size="size" @click="handleClose">取消</el-button>
          <el-button :size="size" type="primary" @click="submitWhiteForm">保存</el-button>
        </span>
    </el-dialog>
    <!-- 授权弹窗 -->
    <el-dialog
      width="500px"
      label-position="center"
      title="授权"
      :visible.sync="authDialogVisible"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :before-close="handleCloseAuth"
    >
      <el-form
        :model="authForm"
        ref="authForm"
        label-width="100px"
        :size="size"
        class="authForm"
        @keyup.enter.native="handleSaveAuth()"
      >
        <div class="auth-item">
          <el-checkbox v-model="authForm.miniMineSendEnable">矿发登记</el-checkbox>
          <el-checkbox v-model="authForm.miniCheckEnable">发运核对</el-checkbox>
          <el-checkbox v-model="authForm.miniSupplyEnable">矿发补录</el-checkbox>
          <el-checkbox v-model="authForm.miniDepositEnable">押金收取</el-checkbox>
        </div>
        <div class="auth-item">
          <el-checkbox v-model="authForm.miniEntryEnable">入场管理</el-checkbox>
          <el-checkbox v-model="authForm.miniLeaveEnable">出厂管理</el-checkbox>
          <el-checkbox v-model="authForm.miniCarNumberEnable">停车场管理</el-checkbox>
          <el-checkbox v-model="authForm.miniCallNumberEnable">手动叫号</el-checkbox>
        </div>
        <div class="auth-item">
          <el-checkbox v-model="authForm.miniAdjustCarEnable">车辆调整</el-checkbox>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :size="size" @click="handleCloseAuth">取消</el-button>
        <el-button :size="size" type="primary" @click="handleSaveAuth">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
import AdjustHistory from './AdjustHistory';

export default {
  components: {
    KtButton,
    AdjustHistory
  },
  data() {
    return {
      isAdjust: false,
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      whiteList: [], //角色列表
      dialogTitle: '新增',
      whiteDialogVisible: false,
      filterForm: {},
      whiteForm: {
        phone: ''
      },
      whiteListRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
      },
      authDialogVisible: false,
      authForm: {},
    };
  },
  mounted() {
    this.getWhiteList();
  },
  methods: {
    // 获取角色列表
    async getWhiteList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      let index = 0
      for (let key in this.filterForm) {
        const val = this.filterForm[key]
        if (val && val !== '') {
          params['searchFieldList[' + index + '].fieldName'] = key
          params['searchFieldList[' + index + '].singleValue'] = val
          index++
        }
      }
      let res = await this.$api.whiteList.getWhiteListResidentMinerList(params)
      this.whiteList = res.data.dtoList;
      this.totalSize = res.data.totalSize;
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getWhiteList();
    },
    //搜索
    handleSearch() {
      this.pageNo = 1;
      this.getWhiteList();
    },

    // 重置搜索
    getReset() {
      this.filterForm = {}
      this.getWhiteList()
    },

    // 关闭弹窗
    handleClose() {
      this.whiteDialogVisible = false
      this.$refs['whiteForm'].resetFields()
    },

    // 显示新增界面
    handleAdd() {
      this.dialogTitle = '新增'
      this.whiteForm = {};
      this.whiteDialogVisible = true
    },

    // 显示编辑界面
    async handleEdit(row) {
      this.dialogTitle = '编辑'
      this.whiteDialogVisible = true;
      this.whiteForm = row
    },

    // 点击调整历史
    getAdjust() {
      const _t = this
      _t.isAdjust = true
    },
    // 接受调整历史子组件传回的值
    AdjustFun(val) {
      const _t = this
      _t.isAdjust = val
    },

    // 提交数据
    submitWhiteForm(){
      this.$refs['whiteForm'].validate(async (valid) => {
        if (valid) {
          let res = await this.$api.whiteList.mAddWhiteListResidentMiner({
            phone: this.whiteForm.phone
          })
          this.whiteDialogVisible = false
          this.$refs['whiteForm'].resetFields()
          this.$message({ message: "保存成功", type: "success" });
          this.getWhiteList()
        }
      })
    },

    //删除
    handleRemove(row) {
      this.$confirm("是否确认将该手机号移除白名单，移除后该手机号将不可登录e集运驻矿员小程序", '提示').then(async () => {
        await this.$api.whiteList.mRemoveWhiteListResidentMiner({
          phone: row.phone,
        })

        this.getWhiteList();
        this.$message({ message: "移除成功", type: "success" });
      });
    },
    // 打开授权弹窗
    handleAuth(row){
      this.authForm = {
        miniCheckEnable: row.miniCheckEnable == 0,
        miniDepositEnable: row.miniDepositEnable == 0,
        miniEntryEnable: row.miniEntryEnable == 0,
        miniLeaveEnable: row.miniLeaveEnable == 0,
        miniMineSendEnable: row.miniMineSendEnable == 0,
        miniSupplyEnable: row.miniSupplyEnable == 0,
        miniCarNumberEnable: row.miniCarNumberEnable == 0,
        miniCallNumberEnable: row.miniCallNumberEnable == 0,
        miniAdjustCarEnable:row.miniAdjustCarEnable == 0,
        phone: row.phone
      }
      this.authDialogVisible = true;
    },
    // 关闭授权弹窗
    handleCloseAuth(){
      this.$refs['authForm'].resetFields()
      this.authDialogVisible = false
    },
    // 保存授权
    async handleSaveAuth(){
      let data = this.authForm
      let res = await this.$api.whiteList.mAuthControl({
        phone: data.phone,
        miniCheckEnable: data.miniCheckEnable ? 0 : 1,
        miniDepositEnable: data.miniDepositEnable ? 0 : 1,
        miniEntryEnable: data.miniEntryEnable ? 0 : 1,
        miniLeaveEnable: data.miniLeaveEnable ? 0 : 1,
        miniMineSendEnable: data.miniMineSendEnable ? 0 : 1,
        miniSupplyEnable: data.miniSupplyEnable ? 0 : 1,
        miniCarNumberEnable: data.miniCarNumberEnable ? 0 : 1,
        miniCallNumberEnable: data.miniCallNumberEnable ? 0 : 1,
        miniAdjustCarEnable:data.miniAdjustCarEnable ? 0 :1
      })

      this.$refs['authForm'].resetFields()
      this.authDialogVisible = false
      this.getWhiteList()
      this.$message({ message: "授权成功", type: "success" });
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.whiteList_box_title {
  display: flex;
  justify-content: space-between;
  padding: 10px 10px 0 0;

  .whiteList_box_title_desc {
    font-size: 18px;
    font-weight: 600;
  }

  .whiteList_box_title_cz {
    color: #25aff3;
    cursor: pointer;
  }
}
.auth-item{
  margin-bottom: 10px;
  &:last-child{
    margin-bottom: 0;
  }
}
.remark{
  padding-bottom: 20px;
}
</style>
<style lang="scss">
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
